import React, { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { I18NProvider, LocaleProvider } from 'client/i18n/context';
import { KeyboardDetectionProvider } from '@spotify-internal/encore-web';
import { BrowserSizeProvider } from './BrowserSize';
import { NetworkRoleProvider } from './NetworkRole';
import { UnsavedChangesWarningProvider } from './UnsavedChangesWarning';
import { FeatureFlagsProvider } from './FeatureFlags';
import { CurrentUserProvider } from './CurrentUser';
import { ExperimentationProvider } from './Experimentation';
import { ReactQueryProvider } from './ReactQuery';
import { QuickUploadFileProvider } from './QuickUploadFile';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <HelmetProvider>
      <CurrentUserProvider>
        <ExperimentationProvider>
          <LocaleProvider>
            <I18NProvider>
              <ReactQueryProvider>
                <FeatureFlagsProvider>
                  <UnsavedChangesWarningProvider>
                    <NetworkRoleProvider>
                      <BrowserSizeProvider>
                        <QuickUploadFileProvider>
                          <KeyboardDetectionProvider>
                            {children}
                          </KeyboardDetectionProvider>
                        </QuickUploadFileProvider>
                      </BrowserSizeProvider>
                    </NetworkRoleProvider>
                  </UnsavedChangesWarningProvider>
                </FeatureFlagsProvider>
              </ReactQueryProvider>
            </I18NProvider>
          </LocaleProvider>
        </ExperimentationProvider>
      </CurrentUserProvider>
    </HelmetProvider>
  );
}
